import React, {FC} from 'react';
import {Space, Typography} from 'antd';
import './App.less';
import Header from "./components/header/header";
import Result from "./components/result/result";


const App: FC = () => (
    <Space direction="vertical" style={{width: "100%", paddingTop: 20}}>
        <Typography.Text style={{paddingLeft: 20}}>
            Работает только в <a href="https://www.google.com/intl/ru_ru/chrome/" target="_blank">Chrome</a> с отключенным CORS (плагин <a href="https://chrome.google.com/webstore/detail/cors-unblock/lfhmikememgdcahcdlaciloancbhjino" target="_blank">CORS Unlock</a>)
        </Typography.Text>
        <Header />
        <Result />
    </Space>
);

export default App;
